module.exports = __webpack_public_path__ + "static/media/flag_eu.a01fc226.svg";